/* ================================================== */
/* REVEAL
/* ================================================== */

$(document).ready(function() {
	window.sr = ScrollReveal();
	sr.reveal('.reveal-distance', {
		distance: '30px'
	});

	sr.reveal('.reveal-scale', {
		distance: '10%',
		opacity: 0,
		scale: 0.75,
		reset: true
	});
});